import React from 'react';
import Image from 'next/image';

interface Product {
  id: string;
  name: string;
  price: string;
  imageSrc: string;
  imageAlt: string;
  href: string;
  soldOut?: boolean;
}

const coffeeProducts: Product[] = [
{
  id: '1',
  name: 'The Apalach',
  price: '$16.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/products/APALACHMocksmall_540x.jpg?v=1579651009',
  imageAlt: 'The Apalach coffee bag product',
  href: '/checkout'
},
{
  id: '2',
  name: 'SGI Sunrise (USDA Organic)',
  price: '$16.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/products/SGISUNRISEMocksmall_540x.jpg?v=1579652291',
  imageAlt: 'SGI Sunrise USDA Organic coffee bag product',
  href: '/checkout'
},
{
  id: '3',
  name: 'Get Hooked (USDA Organic)',
  price: '$16.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/products/GetHookedSmall_1_540x.jpg?v=1591792380',
  imageAlt: 'Get Hooked USDA Organic coffee bag product',
  href: '/checkout'
},
{
  id: '4',
  name: 'Dockside',
  price: '$16.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/products/DOCKSIDEMocksmall2_1_540x.jpg?v=1579656357',
  imageAlt: 'Dockside coffee bag product',
  href: '/checkout'
},
{
  id: '5',
  name: 'Bayside Reserve',
  price: '$16.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/products/BaysideReservemock_540x.jpg?v=1599232456',
  imageAlt: 'Bayside Reserve coffee bag product',
  href: '/checkout'
},
{
  id: '6',
  name: 'Eastpoint Special (espresso blend)',
  price: '$16.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/products/EASTPOINTSpecialMocksmall_540x.jpg?v=1579651993',
  imageAlt: 'Eastpoint Special espresso blend coffee bag product',
  href: '/checkout'
},
{
  id: '7',
  name: 'Bayside House Espresso Blend',
  price: '$16.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/products/Screenshot2023-03-01at2.08.13PM_540x.png?v=1677698635',
  imageAlt: 'Bayside House Espresso Blend coffee bag product',
  href: '/checkout'
},
{
  id: '8',
  name: 'Old Florida Blend',
  price: '$18.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/files/IMG_5218_540x.heic?v=1751402516',
  imageAlt: 'Old Florida Blend coffee bag product',
  href: '/checkout'
}];


function ProductCard({ product }: {product: Product;}) {
  return (
    <div className="product-card">
      <a href={product.href} className="product-card__link" aria-label={product.name}>
        <div className="product-card__image-wrapper">
          <Image
            src={product.imageSrc}
            alt={product.imageAlt}
            fill
            className="product-card__image"
            style={{ objectFit: 'contain' }}
            sizes="(max-width: 749px) 100vw, 50vw" />
          
        </div>
      </a>
      <div className="product-card__title">{product.name}</div>
      <div className="product-card__price">
        <span className="price-label">Regular price</span>
        <span className="price-value">{product.price}</span>
      </div>

      <style jsx>{`
        .product-card {
          font-family: 'Work Sans', sans-serif;
        }
        .product-card__link {
          display: block;
          text-decoration: none;
        }
        .product-card__image-wrapper {
          position: relative;
          width: 100%;
          padding-top: 100%;
          background: #f5f5f5;
          overflow: hidden;
        }
        .product-card__title {
          margin-top: 10px;
          font-size: 17px;
          font-weight: 400;
          color: #3d4246;
          font-family: 'Work Sans', sans-serif;
        }
        .product-card__price {
          margin-top: 4px;
          font-size: 15px;
          color: #3d4246;
        }
        .price-label {
          display: none;
        }
        .price-value {
          font-weight: 400;
        }
      `}</style>
    </div>);

}

export default function ShopSection() {
  return (
    <section id="shop" className="shop-section">
      <div className="page-width">
        <div className="section-header">
          <h2 className="section-title">Shop Online!</h2>
        </div>
        <ul className="products-grid">
          {coffeeProducts.map((product) =>
          <li key={product.id} className="products-grid__item">
              <ProductCard product={product} />
            </li>
          )}
        </ul>
      </div>

      <style jsx>{`
        .shop-section {
          padding: 50px 0;
          font-family: 'Work Sans', sans-serif;
        }
        .page-width {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 30px;
        }
        .section-header {
          text-align: center;
          margin-bottom: 30px;
        }
        .section-title {
          font-size: 20px;
          font-weight: 600;
          color: #3d4246;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin: 0;
          font-family: 'Work Sans', sans-serif;
        }
        .products-grid {
          list-style: none;
          margin: 0;
          padding: 0;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px 20px;
        }
        @media (max-width: 749px) {
          .products-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>);

}